





























































import Promote from '~/components/car/classifieds/promote/Promote.vue'
import PromoteInfoTip from '~/components/car/classifieds/promote/PromoteInfoTip.vue'
import PaidCreditsFunctionalityBadge from '~/components/shared/badges/PaidCreditsFunctionalityBadge.vue'
import {
  vue3Model,
  computed,
  defineComponent,
  ref
} from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    PaidCreditsFunctionalityBadge,
    PromoteInfoTip,
    Promote
  },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    classified: { type: Object, required: true },
    refetchFunction: {
      type: Function,
      required: false,
      default: null
    },
    inSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    inIframe: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  setup(props, { emit }) {
    const showHelp = ref(false)

    const preferredPayment = ref('stripe')
    function handleFetchPromoComplete(preferredPaymentMethod: string) {
      preferredPayment.value = preferredPaymentMethod
    }

    const isPreferredPaymentStripe = computed(
      () => preferredPayment.value === 'stripe'
    )

    const visible = computed({
      get: () => props.modelValue,
      set: (value: boolean) => {
        emit('update:modelValue', value)
      }
    })

    function onModalClose() {
      visible.value = false
    }

    return {
      onModalClose,
      showHelp,
      isPreferredPaymentStripe,
      visible,
      handleFetchPromoComplete
    }
  }
})
